import React from 'react'
import { Area, AreaChart, defs, LineChart, Line, linearGradient, stop, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"]

export default function Chart(props){
  return(
    <ResponsiveContainer width={'98%'} aspect={3}>
      <LineChart width={1400} height={400} data={props.data}>
        <Line 
          type="monotone" 
          dot={{ 
            stroke: COLORS[props.index % COLORS.length]  || "#63c2de", 
            strokeWidth: 4 }} 
          activeDot={{ stroke: 'white', strokeWidth: 2 }} 
          dataKey={props.dataKey ? props.dataKey : "pv"}
          stroke={COLORS[props.index % COLORS.length]  || "#63c2de"}
          strokeWidth={4} />
        <Tooltip content={<CustomTooltip />} />
        <YAxis dataKey="get_score" label={{ value: 'Score', angle: -90, position: 'outside' }} />
        <XAxis dataKey="formatted_created_at" padding={{ right: 60 }} />
      </LineChart>
    </ResponsiveContainer>
  )
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div className="custom-tooltip border p-1" style={{backgroundColor: 'white'}}>
      <div><b>Score:</b> {payload[0].value}</div>
      <div><b>Submitted On:</b> {moment(payload[0].payload.created_at).format("MM/DD/YYYY @ h:mm:ssA")}</div>
      </div>
    );
  }

  return null;
};